import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

export const useTransactionTypeSelectOptions = () => {
    const { t } = usePaldockTranslation("general.conversion_types");

    const options = [
        { label: t("sale"), value: "sale" },
        { label: t("prospect"), value: "prospect" },
        { label: t("click"), value: "click" },
    ];

    return { options, loading: false, error: null };
};